module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main wow fadeInUp",
    attrs: {
      "data-wow-duration": "1s",
      "data-wow-delay": "0"
    }
  }, [_c('div', {
    staticClass: "txtcontent strip"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "wow2"
  }, [_vm._v("讓他們從這裡開始，用自己的方式，發展他們美麗的樣子，讓他們在現實世界裡，以自己的美麗，自給自足、自在生活。")]), _c('a', {
    staticClass: "btn wow3",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "trackWaitJump('btn_morestories','https://taiwancurio.wordpress.com/')"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 41.24 35.64"
    }
  }, [_c('title', [_vm._v("read")]), _c('path', {
    attrs: {
      "d": "M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z"
    }
  })])]), _c('span', [_vm._v("瞭解更多多寶故事")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banana wow fadeIn",
    attrs: {
      "id": "banana",
      "data-wow-duration": ".2s",
      "data-wow-offset": "80",
      "data-wow-delay": ".5s"
    }
  }, [_c('div', {
    staticClass: "b4",
    attrs: {
      "id": "bananatree"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/banana/0.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/blog1.svg"),
      "alt": "站在一個立足點"
    }
  }), _c('br', {
    staticClass: "m_only"
  }), _c('img', {
    staticClass: "secondtxt",
    attrs: {
      "src": require("../../asset/svg/title/blog2.svg"),
      "alt": "小樹終成為大樹"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32a320b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Blog.vue
// module id = 248
// module chunks = 0